// extracted by mini-css-extract-plugin
export var heroMapWrapper = "StrapiHeroMap-module--heroMapWrapper--5de48";
export var mainTitle = "StrapiHeroMap-module--mainTitle--a9cb6";
export var mainTitleWrapper = "StrapiHeroMap-module--mainTitleWrapper--b5dfd";